import { render, staticRenderFns } from "./select-template.vue?vue&type=template&id=5222ecb3&scoped=true"
import script from "./select-template.vue?vue&type=script&lang=js"
export * from "./select-template.vue?vue&type=script&lang=js"
import style0 from "./select-template.vue?vue&type=style&index=0&id=5222ecb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5222ecb3",
  null
  
)

export default component.exports